<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<v-card>
		<v-card-title>
			<h2>Kraje</h2>
			<v-spacer></v-spacer>
		</v-card-title>
		<br/>
		<v-dialog v-model="dialog" max-width="500px">
			<v-btn slot="activator" color="primary" dark class="mb-2">Dodaj kraj akredytacji</v-btn>
			<v-card>
				<v-card-title>
					<span class="headline" v-if="isEdited"> Edycja kraju </span>
					<span class="headline" v-else> Dodaj nowy kraj </span>
				</v-card-title>

				<v-card-text>
					<v-container grid-list-md>
						<v-layout wrap>
							<v-flex xs12 sm6 md12>
								<v-text-field v-model="editedItem.name"
									browser-autocomplete="off"
									v-on:click="discardDuplicateCountryError"
									label="Kraj"
									data-vv-name="countryName"
									data-vv-as="kraj"
									v-validate="'required'"
									:error-messages="vErrors.collect('countryName')"
									aria-label="country name"
									for="accreditation-countries-view-country"
									id="accreditation-countries-view-country"
									@input="discardDuplicateCountryError"
								></v-text-field>
								<v-text-field v-model="editedItem.englishName"
									browser-autocomplete="off"
									label="Angielska nazwa"
									data-vv-name="englishCountryName"
									data-vv-as="angielska nazwa"
									v-validate="'required'"
									:error-messages="vErrors.collect('englishCountryName')"
									aria-label="english country name"
									for="accreditation-countries-view-english-name"
									id="accreditation-countries-view-english-name"
									@input="discardDuplicateCountryError"
								></v-text-field>
							</v-flex>
							<div
								v-if="showDuplicateCountryMessage"
								style="color:red;">
								Kraj {{ editedItem.name }} już istnieje w systemie.
							</div>
						</v-layout>
					</v-container>
				</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="blue" @click="close">Anuluj</v-btn>
					<v-btn color="primary" flat @click="save">{{ isEdited ? "Zapisz" : "Utwórz"}}</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<div>
			<v-btn @click="exportData" color="primary" dark class="mb-2">Eksportuj</v-btn>
		</div>
		<v-data-table
			:headers="dataTable.tableHeaders"
			:rows-per-page-items="[10,20,25]"
			:loading="dataTable.loading"
			:items="dataTable.itemList"
			:total-items="dataTable.itemCount"
			:pagination.sync="dataTable.pagination"
		>
			<template slot="items" slot-scope="props">
				<td class="text-xs-left">{{ props.item.name }}</td>
				<td class="text-xs-left">{{ props.item.englishName }}</td>
				<td class="text-xs-left">
					<v-tooltip bottom>
						<template v-slot:activator="{ on }" >
							<v-btn icon
								@click="editItem(props.item)" >
								<v-icon v-on="on">
									edit
								</v-icon>
							</v-btn>
						</template>
						<span>Edytuj</span>
					</v-tooltip>
					<v-tooltip bottom>
						<template v-slot:activator="{ on }" >
							<v-btn icon
								@click="deleteItem(props.item)" >
								<v-icon color="lightred" v-on="on">
									delete
								</v-icon>
							</v-btn>
						</template>
						<span>Usuń</span>
					</v-tooltip>
				</td>
			</template>
		</v-data-table>
	</v-card>
</template>

<script>
	import {Api} from "../../../api";
	import {ExportUtils} from "../../../utils/ExportUtils";
	import {AccreditationCountry} from "../../../api/generated/AccreditationCountry";

	export default {
		name: "AccreditationCountriesView",
		watch: {

			"dataTable.pagination": {
				handler() {
					this.getItemList();
				},
				deep: true
			},

			dialog(val) {
				!val && (this.editedIndex = -1) && (this.editedItem = {});
				this.discardDuplicateCountryError();
			},

		},

		computed: {

			isEdited() {
				return this.editedIndex !== -1;
			},
		},

		data() {
			return {
				dataTable: {
					searchFields: {},
					tableHeaders: [
						{
							text: "Kraj",
							sortable: true,
							value: "name"
						},
						{
							text: "Angielska nazwa",
							sortable: true,
							value: "englishName"
						},
						{
							text: "Akcje",
							sortable: false,
						},
					],
					loading: false,
					itemList: [],
					itemCount: 0,
					pagination: {
						rowsPerPage: 25,
					},
					search: "",
				},

				dialog: false,

				showDuplicateCountryMessage: false,

				editedItem: {},

				editedIndex: -1,
			};
		},

		methods: {

			exportData () {
				this.dataTable.search = this.buildSearch(this.dataTable.searchFields);
				let sort = this.buildSort();
				let path = "/accreditation-country/export?search=" + this.dataTable.search
					+ "&sort=".concat(sort);
				ExportUtils.sendExportRequest(path, this);
			},

			getItemList() {
				this.dataTable.search = this.buildSearch(this.dataTable.searchFields);
				let sort = this.buildSort();
				Api.get(this,
					"/accreditation-country/list?search=" + this.dataTable.search
						+ "&page=" + this.dataTable.pagination.page
						+ "&result=" + this.dataTable.pagination.rowsPerPage
						+ "&sort=".concat(sort), response => {
							this.dataTable.itemList = response.itemList;
							this.dataTable.itemCount = response.itemCount;
						});
			},

			resetSearch() {
				this.clearFields();
				this.getItemList();
			},

			clearFields() {
			},

			/* eslint-disable */
			buildSearch(searchFields) {
				let search = "";
				return search;
			},

			buildSort() {
				let order = this.dataTable.pagination.descending === true ? "desc" : "asc";
				let columnName = this.dataTable.pagination.sortBy;
				if (order && columnName) {
					return columnName.concat(" ").concat(order);
				} else {
					return "";
				}
			},

			discardDuplicateCountryError() {
				this.showDuplicateCountryMessage = false;
			},

			editItem(item) {
				this.editedIndex = this.dataTable.itemList.indexOf(item);
				this.editedItem = Object.assign({}, item);
				this.dialog = true;
			},

			deleteItem(item) {
				this.$confirm("Czy na pewno chcesz usunąć kraj?", {
					icon: 'delete',
					title: 'Usuwanie kraju',
					color: 'lightred',
					width: 500
				})
					.then(response => {
						if (response) {
							const index = this.dataTable.itemList.indexOf(item);
							AccreditationCountry.delete(this, item.id, successResponse => {
									this.dataTable.itemList.splice(index, 1);
									this.$messagesBus.$emit("success", "Kraj został pomyślnie usunięty", successResponse);
								},
								errorResponse => {
									this.$messagesBus.$emit("error", "Nie udało się usunąć kraju, prawdopodobnie został użyty w systemie.", errorResponse);
								});
						}
					});
			},

			close() {
				this.dialog = false;
				this.editedIndex = -1;
				this.editedItem = {};
			},

			save() {
				this.$validator.validateAll().then(result => {
					if (!result) {
						return;
					}
					if (this.editedIndex > -1) {
						AccreditationCountry.put(this, this.editedItem, successResponse => {
							Object.assign(this.dataTable.itemList[this.editedIndex], this.editedItem);
							this.close();
							this.$messagesBus.$emit("success", "Kraj został pomyślnie zapisany", successResponse);
						}, errorResponse => {
							this.showDuplicateCountryMessage = true;
							this.$messagesBus.$emit("error", "Nie udało się zapisać kraju", errorResponse);
						});
					} else {
						AccreditationCountry.post(this, this.editedItem, successResponse => {
							this.editedItem.id = successResponse;
							this.dataTable.itemList.push(this.editedItem);
							this.close();
							this.$messagesBus.$emit("success", "Kraj został pomyślnie dodany", successResponse);
						}, errorResponse => {
							this.showDuplicateCountryMessage = true;
							this.$messagesBus.$emit("error", "Nie udało się dodać kraju", errorResponse);
						});
					}
				});

			},
		},
	};
</script>

<style scoped>

</style>
